import React from "react"

import styled from "styled-components"
import { device } from "breakpoints"

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  margin-right: -10px;
  margin-bottom: -10px;

  justify-content: center;

  @media ${device.desktop} {
    margin-right: -60px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  > * {
    width: 98px;
    margin-right: 10px;
    margin-bottom: 10px;

    @media ${device.desktop} {
      width: 142px;
      margin-right: 60px;
      margin-bottom: 20px;
    }
  }
`

const Logos = ({ items }) => {
  return (
    <Wrapper>
      {items.map((item, index) => {
        return <img key={index} src={item.image.url} />
      })}
    </Wrapper>
  )
}

export default Logos
